<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-0"
    >
        Confirm Payment
    </h2>
    <hr class="border-gray-300" />

    <mat-dialog-content class="!px-6 !pt-5 mat-typography">
        <form [formGroup]="form" class="flex flex-col gap-5">
            <mat-form-field
                appearance="outline"
                class="w-8/12"
                subscriptSizing="dynamic"
            >
                <mat-label>Payment Method</mat-label>
                <mat-select
                    [formControl]="form.controls.paymentMethod"
                    panelWidth="w-full"
                >
                    @for (
                        option of paymentMethodDropdownOptions;
                        track option.value
                    ) {
                        <mat-option
                            [value]="option.value"
                            [disabled]="option.disabled"
                        >
                            {{ option.label }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="w-4/12"
                subscriptSizing="dynamic"
            >
                <mat-label>Amount</mat-label>
                <input
                    matInput
                    [formControl]="form.controls.amount"
                    placeholder="Amount"
                    [imask]="paymentTransactionAmountMaskConfig"
                    [unmask]="'typed'"
                />
                @if (getAmountMaxError(); as error) {
                    <mat-error>{{ error }}</mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="w-8/12"
                subscriptSizing="dynamic"
            >
                <mat-label> Description </mat-label>
                <input
                    matInput
                    [formControl]="form.controls.description"
                    placeholder="Description"
                    [appRegexInput]="
                        regexPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    [maxlength]="255"
                />
                <mat-hint
                    >Enter the check number or EFT reference
                    information</mat-hint
                >
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="!pb-5 !pr-5 !gap-3">
        <button
            type="button"
            mat-stroked-button
            color="primary"
            class="!border-primary-700"
            (click)="cancel()"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            type="button"
            name="Save"
            cdkFocusInitial
            color="primary"
            [disabled]="form.invalid"
            (click)="save()"
        >
            Save
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
